import { Component, OnDestroy, OnInit ,ViewChild, TemplateRef} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Socket } from 'ngx-socket-io';
import { ToastrService } from 'ngx-toastr';
import { UsersService } from '../services/users.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
declare var bootstrap: any;
@Component({
  selector: 'app-eventplayerbattle',
  templateUrl: './eventplayerbattle.component.html',
  styleUrls: ['./eventplayerbattle.component.scss']
})
export class EventplayerbattleComponent implements OnInit{
  @ViewChild('optionmodal') optionmodal!: TemplateRef<any>;
  marketId: any;
  userDetails: any;
  ContestList: any = [];
  BetList: any = [];
  selectedRunners: any[] = [];
  selectedSelectionIds: any[] = [];
  session_db: any;
  betloder = false;
  browser_details: any = { browserdetail: '', ipaddress: '' };
  userSelectedList: any[] = [];
  computerSelectedList: any[] = [];
  selectedUser: any;
  selectedIds: Set<number> = new Set();
  Teamlistshow: boolean = false;
  amount: number | null = null;
  showbtn: boolean = true;
  allPlayerArrAll: any;
modaloption?: BsModalRef;
userPoint:any;
computerPoint:any;
  constructor( private activatdRoute: ActivatedRoute, private route: Router,  private modalService: BsModalService,private socket: Socket,private toastr: ToastrService,public httpClient:UsersService) 
  {
    this.userDetails=JSON.parse(sessionStorage.getItem('userDetails'));
     this.activatdRoute.paramMap.subscribe((param) => {
      this.marketId = param.get("id");
      this.userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
      if (JSON.parse(sessionStorage.getItem("address_info"))) {
        this.browser_details = JSON.parse(sessionStorage.getItem("address_info"));

      }
    });
   }

  ngOnInit(): void {
    if (this.userDetails?.details?._id) {
      const data = {
        user_id: this.userDetails.details._id,
        marketId: this.marketId
      };
      this.get(data);
      this.getBets();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
     this.openOption(this.optionmodal);
    }, 300);
  }


  get(data: any): void {
    this.httpClient.SocketPost('get-playbattle-market', data).subscribe(
      (res: any) => {
        if (res?.response) {
          this.ContestList = res.response;
        this.userPoint= this.ContestList?.marketBook?.userPoint;
         this.computerPoint= this.ContestList?.marketBook?.computerPoint;
        } else {
          this.ContestList = [];
        }
      },
      (error) => {
        console.error('Error fetching contests:', error);
      }
    );
  }

  formatReadableDate(apiDate: string) {
    const date = new Date(apiDate);
    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };

    return date.toLocaleString("en-GB", options).replace(",", "");
  }
  selectPlayer(player: any) {
    if (this.selectedIds.has(player.selectionId)) return;
    this.userSelectedList.push(player);
    this.selectedIds.add(player.selectionId);
    this.selectComputerPlayer();
  }
  selectComputerPlayer() {
    const runners = this.ContestList?.marketBook?.runners || [];
    const available = runners.filter(r => !this.selectedIds.has(r.selectionId));
    if (!available.length) return;
    const best = available.sort((a, b) => b.runs - a.runs)[0];
    this.computerSelectedList.push(best);
    this.selectedIds.add(best.selectionId);
  }
  isUserSelected(id: number): boolean {
    return this.userSelectedList.some(u => u.selectionId === id);
  }

  isComputerSelected(id: number): boolean {
    return this.computerSelectedList.some(c => c.selectionId === id);
  }

  selectFirst(type: 'user' | 'computer') {
    if (type === 'user') {
      this.selectedUser = 1;
    } else {
      this.selectedUser = 2;
      this.selectComputerPlayer();
    }
   this.modaloption.hide();
  }
  clearteam() {
    this.userSelectedList = []
    this.computerSelectedList = []
    this.selectedIds = new Set();
    this.showbtn = true;
    this.Teamlistshow = false
   
     this.openOption(this.optionmodal);
    
  }
  SaveTeam() {
    this.Teamlistshow = true
    this.showbtn = false
  }

  getBets(): void {
    const data = {
      filter: { result: "ACTIVE", eventTypeId: "3901", marketId: this.marketId, username: this.userDetails.details.username },
      user_id: this.userDetails?.details?._id
    }
    this.httpClient.SocketPost('get-playbattle-bet', data).subscribe(
      (res: any) => {
        if (res?.response) {
          this.BetList = res.response;
        } else {
          this.BetList = [];
        }
      },
      (error) => {
        console.error('Error fetching contests:', error);
      }
    );
  }
  SaveBet() {

    this.userSelectedList = this.userSelectedList.map(item => {
      return { ...item, selected: 1 };
    });

    this.computerSelectedList = this.computerSelectedList.map(item => {
      return { ...item, selected: 2 };
    });
    // this.selectedUser = 1
    this.allPlayerArrAll = [
      ...this.userSelectedList,
      ...this.computerSelectedList
    ];
    // console.log("all Array", this.allPlayerArrAll)
    // console.log("User", this.userSelectedList)
    // console.log("computer", this.computerSelectedList)
    // this.amount = 0
    if (!this.amount) {
      this.toastr.error("Please enter amount first!");
      return;
    }

    const sessionBet = {
      user: this.userDetails,
      bet: {
        runnerId: this.allPlayerArrAll,
        selectionName: this.selectedUser,
        rate: 0,
        runnerRuns: 0,
        stake: this.amount,
        market: this.ContestList,
        type: 'Back'
      }
    };
    this.session_db = sessionBet;
    // console.log("BET DATA", this.session_db)
    // return;
    this.createBetContest(this.session_db);
  }
  createBetContest(data: any) {
    // console.log("Create Bet Contest Data:", data);
    this.socket.emit("create-playerbet", data);
    this.socket.on("place-bet-success", (res: any) => {
      this.toastr.success(res.message);
      this.amount = 0
      this.selectedIds = new Set();
      this.allPlayerArrAll = []
      this.userSelectedList = []
      this.computerSelectedList = []
      this.Teamlistshow = false
      this.showbtn = true
      this.socket.removeListener("place-bet-success");
      this.getBets()
    });
    this.socket.on("place-bet-error", (err: any) => {
      this.toastr.error(err.message);
      this.socket.removeListener("place-bet-error");
      this.socket.removeListener("place-bet-success");
    });
  }
 openOption(optionmodal: TemplateRef<any>) {
    this.modaloption = this.modalService.show(
      optionmodal,
      { class: 'success modal-lg' }
    );
  }
}
function ngAfterViewInit() {
  throw new Error('Function not implemented.');
}

